import FerryCreate from '@/controllers/ferry/ferry-create.js';

export default {
  extends: FerryCreate,
}
